// extracted by mini-css-extract-plugin
export default {"author":"Author_author__7c-5C","searchInput":"Author_searchInput__UXiZq","dropdownList":"Author_dropdownList__XJtvU"};